import BaseOption from "%/dynamic-component-editor/classes/base-option";
import OptionExpression from "@bloglovin/inspire-engine/Helpers/OptionExpression.js";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import ProgressBarRange from "%/dynamic-component-editor/standard-elements/progress-bar/ProgressBarRange";

export default class ProgressBarValue extends BaseOption {

  // -------------------//
  // Static Class Vars //
  // -------------------//

  static userInterfaceComponent = {
    label: "Value",
    component: inspectorTools.SIMPLE_INPUT,
    useVerticalOrientation: false,
    props: {
      inputType: "number",
    },
  };

  static defaultValue = 50;

  static bindableDataType = "float";

  static expressionEditable = true;

  // -----------------------//
  // Public Static Methods //
  // -----------------------//

  static convertConfigValueToCompiledValue(configValue) {
    if (OptionExpression.isToken(configValue)) {
      return configValue;
    }
    return ProgressBarRange.toNumber(configValue, 0);
  }
}
